import React from 'react';
import styles from './Experience.module.css';

const experienceData = [
  {
    company: 'edX (a subsidiary of 2U)',
    title: 'Senior Software Engineer I',
    dates: 'September 2019 - June 2025',
    description: [
      'Core contributor of the Open edX (OeX) open source software project (https://github/openedx).',
      'Reduced course certificate support issues by 51% after a substantial redesign and refactor of the OeX credentialing features.',
      'Integrated Kafka Event Bus support in the OeX Credentials microservice, enhancing communication between core services and reducing customer support issues.',
      'Built multiple Snowflake Data marts (using DBT), powering integrations for internal and external consumers.',
      'Developed a highly requested scheduled email feature for the OeX platform, enhancing instructor engagement and automation.',
      'Maintainer of a hosted development environment used across multiple engineering teams.',
      'Led Agile team processes for 4+ years.',
      'Summer Intern mentor for 2+ years',
    ]
  },
  {
    company: 'Symantec',
    title: 'Software Engineer',
    dates: 'April 2014 - August 2019',
    description: [
      'Joined as a Software Quality Assurance Engineer in 2014, promoted to Software Engineer in 2016.',
      'Delivery of a REST API translation microservice for the rapid integration of the Fireglass Android app after acquisition by Symantec.',
      'Redesign of a multi-platform Mobile Device management REST API so it coudl be decoupled from a monolith and consumed by multiple Symantec products.',
      'Redesign of an Android agent (SEP Cloud) that combined two separate Symantec Android apps into a single offering for customers.',
      'Reworked team testcase repository, identifying missing manual and automated tests for high impact user-facing features.',
      'Developed an automated test suite for the SEP Cloud Android agent using UIAutomator.',
    ]
  },
  {
    company: 'Tangoe',
    title: 'Software Support Engineer',
    dates: 'January 2013 - April 2014',
    description: [
      'Consistently closed out the largest overall number of support tickets per month, with the highest satisfaction ratings among team members.',
      'Assisted customers via email, phone, and remote debugging sessions to resolve support requests for Tangoe\'s mobile Device Manager product.',
    ]
  },
  {
    company: 'AKUITY Technologies',
    title: 'Systems Engineer I',
    dates: 'March 2011 - January 2013',
    description: [
      'Joined as a helpdesk intern in March 2011, promoted to Systems Engineer I in August of 2011.',
      'Provided onsite desk-side IT service and consultation services, resolving hardware and software issues for businesses in the New England area.',
    ]
  },
];

const Experience = () => {
  return (
    <section id="experience" className={styles.experience}>
      <h2>Work Experience</h2>
      <div className={styles.timeline}>
        {experienceData.map((job, index) => (
          <div key={index} className={styles.job}>
            <h3 className={styles.company}>{job.company}</h3>
            <p className={styles.title}>{job.title}</p>
            <p className={styles.dates}>{job.dates}</p>
            <ul className={styles.description}>
              {job.description.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Experience;
